import { HIDE_PAYMENT_MIR_ID } from '../constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export const useHidePaymentMir = () => {
  return useHideSomeExperiment(HIDE_PAYMENT_MIR_ID);
};
